<template>
  <div class="add-header-container">
    <span class="backIcon" @click="backMain"></span>
    <div class="title">
      {{ title }} <span v-if="isShowId">Duplicated from {{showId}}</span> <slot name="line"></slot> <slot name="ids"></slot><slot name="ownerName"></slot>
    </div>
    <div class="add__header-right">
      <slot name="header-right" />
    </div>
    <slot/>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    showId: {
      type: String,
      default: "",
    },
    isShowId: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    backMain() {
      this.$emit("backMain");
      // this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.add-header-container {
  height: 90px;
  line-height: 90px;
  padding: 0 24px;
  // margin-bottom: 10px;
  background: #ffffff;
  display: flex;
  align-items: center;
  .backIcon {
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url("~@/assets/img/driver/arrow.svg") no-repeat;
    vertical-align: text-bottom;
    margin-right: 6px;
    cursor: pointer;
  }
  .title {
    font-weight: bold;
    font-size: 20px;
    color: #000000;
    display: inline-block;
    span {
      margin-left: 10px;
      font-size: 12px;
      color: #7f8596;
      font-weight: normal;
    }
  }
  .add__header-right {
    margin-left: auto;
  }
}
</style>
